import React from 'react';
import './StageConversionFunnel.css';

function StageConversionFunnel({ data }) {
    const conversions = data || [];

    const getRateClass = (rate) => {
        if (rate >= 70) return 'rate-high';
        if (rate >= 40) return 'rate-medium';
        return 'rate-low';
    };

    return (
        <div className="conversion-funnel-container">
            <h2 className="conversion-funnel-title">Stage Conversion Funnel</h2>
            <div className="conversion-funnel-table">
                <div className="conversion-table-header">
                    <div className="conversion-col-stage">From Stage</div>
                    <div className="conversion-col-stage">To Stage</div>
                    <div className="conversion-col-count">From Count</div>
                    <div className="conversion-col-count">To Count</div>
                    <div className="conversion-col-rate">Conversion Rate</div>
                </div>
                {conversions.length === 0 ? (
                    <div className="conversion-no-data">No conversion data available</div>
                ) : (
                    conversions.map((conversion, index) => (
                        <div key={index} className="conversion-row">
                            <div className="conversion-col-stage">{conversion.fromStage}</div>
                            <div className="conversion-col-stage conversion-arrow">→ {conversion.toStage}</div>
                            <div className="conversion-col-count">{conversion.fromCount}</div>
                            <div className="conversion-col-count">{conversion.toCount}</div>
                            <div className={`conversion-col-rate ${getRateClass(conversion.conversionRate)}`}>
                                <span className="conversion-rate-value">{conversion.conversionRate.toFixed(1)}%</span>
                                <div className="conversion-rate-bar">
                                    <div
                                        className="conversion-rate-fill"
                                        style={{ width: `${Math.min(conversion.conversionRate, 100)}%` }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

export default StageConversionFunnel;
